export default __webpack_public_path__ + "static/media/mobil.82e783a5.svg";